import { setAppSessionId, setVideoSessionId } from 'store/session/actions';
import {
    SET_APP_SESSION_ID,
    SET_VIDEO_SESSION_ID,
} from 'store/session/constants';
import { SessionState } from 'store/session/reducer.types';

const initialState: SessionState = {
    appSessionId: undefined,
    videoSessionId: undefined,
};

const handlers = {
    [SET_APP_SESSION_ID](
        state: SessionState,
        { payload: { sessionId } }: ReturnType<typeof setAppSessionId>,
    ): SessionState {
        return {
            ...state,
            appSessionId: sessionId,
        };
    },
    [SET_VIDEO_SESSION_ID](
        state: SessionState,
        { payload: { sessionId } }: ReturnType<typeof setVideoSessionId>,
    ): SessionState {
        return {
            ...state,
            videoSessionId: sessionId,
        };
    },
};

export default { initialState, handlers };
